export default "__VITE_ASSET__DoJ9EhQH__"